import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ForYouSection() {
  const items = ['Querés entender a tu hijo sin tener que estudiar años de astrología', 'Estás cansada de reaccionar mal y querer hacerlo diferente', 'Buscás respuestas concretas y no más teorías que suenan bonito pero no se aplican', 'Sabés que tu hijo es único y querés criarlo como tal', 'Querés que tu vínculo con él sea algo que los dos recuerden con amor'];
  return <section className="py-10 px-4 bg-dusty-rose-50 relative overflow-hidden" data-id="element-58">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-50" data-id="element-59"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-dusty-rose-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-60"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-61">
        <FadeIn data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-burgundy-900 mb-12" data-id="element-63">
            Esta colección es para vos si…
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-64">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-65">
              <div className="flex items-center p-5 bg-white/80 backdrop-blur-sm rounded-xl border border-white shadow-sm hover:shadow-md transition-all" data-id="element-66">
                <div className="flex-shrink-0 w-8 h-8 bg-gold-100 rounded-full flex items-center justify-center mr-4 border border-gold-200" data-id="element-67">
                  <span className="text-sm" data-id="element-68">✅</span>
                </div>
                <p className="text-lg text-burgundy-800 font-medium" data-id="element-69">{item}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}